export default __webpack_public_path__ + "static/char-s-06-chs-31f5e5b4dca03922252b8897fefb09be.png";